import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberAdminMessagesPage from "@/pages/member/MemberAdminMessagesPage";

export const Route = createFileRoute("/member/admin-messages")({
  head: () => pageHead("Member · Admin Messages", "AKIVA member · admin messages portal.", "/member/admin-messages", true),
  component: MemberAdminMessagesPage,
});
